import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from '../../Config/Api';
import MasterApi from '../../Config/MasterApi';

export const getIllustrationSPAJ = createAsyncThunk('illustration/ilustrationSPAJ', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.illustrationSPAJ, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

const Ilustration = createSlice(({
    name: "Ilustration",
    initialState: {
        Ilustration: []
    },
    extraReducers: {
        [getIllustrationSPAJ.fulfilled]: (state, action) => {
            state.Ilustration = action.payload.data
        }
    }
}))

export default Ilustration.reducer